<template>
    <v-app-bar
            id="app-bar"
            absolute
            app
            color="transparent"
            flat
            height="75"
    >
        <v-btn
                class="mr-3"
                elevation="1"
                fab
                small
                @click="setDrawer(!drawer)"
        >
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>

        <v-toolbar-title
                class="hidden-sm-and-down font-weight-light"
                v-text="$vuetify.lang.t('$vuetify.page.'+$route.name+'.name')"
        />

        <v-spacer/>

        <notification></notification>

        <v-menu>
            <template v-slot:activator="{ on }">
                <v-btn
                        text
                        dense
                        v-on="on"
                >
                    <v-icon>mdi-cog-outline</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item to="/profile" v-if="profile">
                    <v-list-item-avatar>
                        <v-icon>mdi-account-circle-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{profile.displayName}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout">
                    <v-list-item-avatar>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.menu.logout')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    // Utilities
    import {mapState, mapMutations} from 'vuex'
    import {actionType, getterType} from "@/store/profile";
    import Notification from "@/view/dashboard/components/core/Notification";

    export default {
        name: 'DashboardCoreAppBar',
        created() {
            this.$store.dispatch(actionType.getProfile)
        },
        components: {
            Notification

        },

        props: {
            value: {
                type: Boolean,
                default: false,
            },
        },

        data: () => ({}),

        computed: {
            ...mapState(['drawer']),
            profile() {
                return this.$store.getters[getterType.profile]
            },
        },

        methods: {
            ...mapMutations({
                setDrawer: 'SET_DRAWER',
            }),
            logout() {
                this.$store.dispatch('logoff').then(() => {
                    this.$router.push({name: 'Login'})
                })
            },

        },
    }
</script>
